/*
 *   File : goal-order-detail.js
 *   Author : https://evoqins.com
 *   Description : Goal Order detail page
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';

// custom components
import { StatisticCard } from '../../Components/Card';
import { Chip } from '../../Components/Others';
import { CustomDataTable } from '../../Components/DataTable';
import { OrderTimelineModal } from '../../Components/Modal';

// custom style
import style from "../../Style/Component/order.module.scss";

const ORDER_DATA = [
    {
        fund: "Nippon Indian Large Cap Fund",
        amount: "₹20,000.00",
        unit: "200",
        nav: "200",
        allocated_date: "13 Jul 2023",
        folio_no: "45678765434",
        type: "SIP",
    },
    {
        fund: "Bandhan  Infrastructure Growth plan",
        amount: "₹20,000.00",
        unit: "200",
        nav: "200",
        allocated_date: "13 Jul 2023",
        folio_no: "45678765434",
        type: "SIP",
    },
    {
        fund: "ICICI Prudential Nifty Next 50 Index Fund",
        amount: "₹20,000.00",
        unit: "200",
        nav: "200",
        allocated_date: "13 Jul 2023",
        folio_no: "45678765434",
        type: "SIP",
    },
    {
        fund: "Nippon Indian Large Cap Fund",
        amount: "₹20,000.00",
        unit: "200",
        nav: "200",
        allocated_date: "13 Jul 2023",
        folio_no: "45678765434",
        type: "SIP",
    },
    {
        fund: "Nippon Indian Large Cap Fund",
        amount: "₹20,000.00",
        unit: "200",
        nav: "200",
        allocated_date: "13 Jul 2023",
        folio_no: "45678765434",
        type: "SIP",
    },
    {
        fund: "Nippon Indian Large Cap Fund",
        amount: "₹20,000.00",
        unit: "200",
        nav: "200",
        allocated_date: "13 Jul 2023",
        folio_no: "45678765434",
        type: "SIP",
    },
];

const GoalOrderDetail = () => {

    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [timelineModal, setTimelineModal] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (timelineModal === true) {
            const timeline_modal = new Modal(document.getElementById('timeline-modal'));
            timeline_modal.show();
        }
    }, [timelineModal]);

    // handle view time line 
    const _handleViewTimeLine = (data) => {
        setTimelineModal(true);
    };

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
    };

    // Pending request data table column 
    const ORDER_TABLE_COLUMN = [
        {
            name: 'Funds',
            cell: (row) =>
                <div className='d-flex align-items-center gap-2'>
                    <div className={`${style.e_fund_img_wrapper} e-bg-white padding-2px-all border-radius-4`}>
                        <img src={require("../../Assets/Image/Order/fund.png")}
                            draggable={false}
                            width={20}
                            height={20}
                            alt='fund' />
                    </div>
                    <p className='mb-0'>
                        {row.fund}
                    </p>
                </div>
            ,
            width: "360px"
        },
        {
            name: 'Amount',
            selector: row => row.amount,
            width: "150px"
        },
        {
            name: 'Unit',
            selector: row => row.unit,
            width: "110px"
        },
        {
            name: 'NAV',
            selector: row => row.nav,
            width: "110px"
        },
        {
            name: 'Allocated date',
            selector: row => row.allocated_date,
            width: "160px"
        },
        {
            name: 'Folio no',
            selector: row => row.folio_no,
            width: "160px"
        },
        {
            name: 'Type',
            selector: row => row.type,
            width: "120px"
        },
    ];

    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                        <span className='text-decoration-hover-underline cursor-pointer'
                            onClick={() => navigate("/orders")}>Orders</span> / <span className='e-font-weight-600'>RA123457</span>
                    </p>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    {/* Order summary */}
                    <div className={`${style.e_order_summary_wrapper} e-bg-american-violet border-radius-16 padding-32px-all`}>
                        <div className='d-flex align-items-center gap-12px '>
                            <div className={`${style.e_order_icon_wrapper} border-radius-8 e-bg-white py-2 padding-12px-lr w-max-content`}>
                                <img src={require("../../Assets/Image/Order/order-icon.png")}
                                    draggable={false}
                                    width={20}
                                    height={26}
                                    alt='order-icon' />
                            </div>
                            <h4 className='mb-0 e-text-white e-primary-font e-font-20 e-font-weight-600 line-height-24px'>
                                No sweat invest
                            </h4>
                        </div>

                        {/* Statistic cards */}
                        <div className='row row-cols-6 row-gap-4 pt-4 mt-2'>
                            <div className='col'>
                                <StatisticCard title="Order ID"
                                    value="RA123456" />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Executed on"
                                    value="12 Jun 2024" />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Amount invested"
                                    value="₹5,02,345.87" />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Type"
                                    value="SIP" />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Order status"
                                    value={
                                        <Chip label="Success"
                                            className="e-bg-green-crayola padding-2px-tb" />
                                    } />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Payment status"
                                    value={
                                        <Chip label="Success"
                                            className="e-bg-green-crayola" />
                                    } />
                            </div>
                        </div>
                    </div>

                    {/* Order details */}
                    <div className={`${style.e_order_detail_table_wrapper} e-bg-ghost-white border-radius-16 margin-32px-top`}>
                        <div className='padding-32px-lr padding-32px-top'>
                            <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                Order details
                            </h4>
                        </div>
                        {/* Order list table */}
                        <div className='e-data-table-wrapper pt-4 padding-32px-bottom'>
                            <CustomDataTable columns={ORDER_TABLE_COLUMN}
                                data={ORDER_DATA}
                                pagination={true}
                                paginationPerPage={10}
                                paginationTotalRows={ORDER_DATA.length}
                                onChangePage={_handleTablePageChange}
                                rowClick={_handleViewTimeLine} />
                        </div>
                    </div>
                </div>
            </section>

            {/* Order timeline modal */}
            {timelineModal === true &&
                <OrderTimelineModal
                    handleClose={() => {
                        setTimeout(() => {
                            setTimelineModal(false);
                        }, 200);
                    }} />
            }
        </Fragment>
    )
}

export default GoalOrderDetail;
